<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->
    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="dialog2 = false"
              >Disagree</v-btn
            >
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
              >Agree</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->
    <v-progress-circular
      v-if="Loader"
      :size="70"
      :width="7"
      color="teal"
      indeterminate
    ></v-progress-circular>

    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card-text class="pb-0">
        <v-container grid-list-md class="pb-0">
          <v-layout wrap>
            <v-flex xs12 sm4 md6>
              <v-autocomplete
                label="Eco Code"
                item-text="eco_name_no"
                item-value="id"
                :items="eco_head"
                @change="checkEco($event)"
                v-model="formSchema.eco_head_id"
                :rules="[(v) => !!v || 'Field is required']"
                required
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm4 md6>
              <v-text-field
                label="Eco Code Name"
                v-model="formSchema.eco_code"
                readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm4 md6>
              <v-text-field
                label="Amount"
                v-model="formSchema.amount"
                :rules="[(v) => !!v || 'Field is required']"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-form>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="previous">
        <v-icon>arrow_back_ios</v-icon>Previous
      </v-btn>
      <v-btn color="primary" @click="submitEcoHeadAmount">
        Save & Next
        <v-icon>arrow_forward_ios</v-icon>
      </v-btn>
      <v-btn color="secondary" @click="reset">
        Reset
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-btn color="blue darken-1" flat @click.native="home">Home</v-btn>
    </v-card-actions>

    <v-card class="mb-3 mt-3 table-responsive" color="lighten-1">
      <v-data-table class="elevation-4" :headers="headers" :items="items">
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.index + 1 }}</td>
          <td class="text-xs-left">{{ props.item.eco_head_id }}</td>
          <td class="text-xs-left">{{ props.item.eco_code }}</td>
          <td class="text-xs-left">{{ props.item.amount | currency }}</td>

          <td class="justify-center layout px-0">
            <v-btn icon class="mx-0" @click="editItem(props.index, props.item)">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <v-btn
              icon
              class="mx-0"
              @click="deleteItem(props.index, props.item.id)"
            >
              <v-icon color="pink">delete</v-icon>
            </v-btn>
          </td>
        </template>

        <template slot="no-data" class="error">
          <div align="center">No Data Found</div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
const commonService = require("../../../../services/common.service");

export default {
  props: ["package_id"],
  data: () => ({
    valid: true,
    e1: 0,
    show: false,
    Loader: false,
    //operation_act_id: 1,
    items: [],
    snackbar: false,
    color: "success",
    mode: "",
    dialog2: false,
    timeout: 3000,
    left: "left",
    message: "",
    eco_head: [],
    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },
    formSchema: {
      id: "",
      package_id: sessionStorage.getItem("package_info"),
      eco_head_id: "",
      eco_code: "",
      amount: "",
    },
    headers: [
      {
        text: "SL",
      },
      {
        text: "Head",
        align: "left",
        sortable: true,
        value: "eco_head_id",
      },
      { text: "Eco Code Name", align: "left", sortable: true, value: "eco_code" },
      { text: "Amount", align: "left", sortable: true, value: "amount" },

      { text: "Action", value: "" },
    ],
  }),

  created() {
    this.loadData();
    commonService.getAllData("economy-code-info").then((res) => {
      this.eco_head = res.data;
      this.eco_head.forEach((c,i,f)=>{
          c.eco_name_no = c.eco_account_name+' ('+c.eco_account_code+')'
      })
    });
  },

  methods: {
    checkEco(e) {
      this.eco_head.find((value) => {
        if (value.id == e) {
          this.formSchema.eco_code = value.eco_account_name;
        }
      });
    },
    getDataFromApi() {
      commonService.getAllData("proc_package_eco").then((res) => {
        // this.items = res.data;
        this.loading = false;
      });
    },
    loadData() {
      let formSchema = this.formSchema;
      commonService
        .getAllDataById(this.operation_act_id, "proc_package_eco")
        .then((res) => {
          if (res.data) {
            this.formSchema = res.data;
          }
          this.show = true;
        });
    },

    home() {
      this.$router.push("/procurement/package_revision");
    },

    submitEcoHeadAmount() {
      let root = this;
      this.Loader = true;
      let formSchema = this.formSchema;

      if (formSchema.id > 0) {
        commonService
          .updateFormData(formSchema, "proc_package_eco")
          .then((res) => {
            if (res.status == 1) {
              let actionData = {
                message: res.message,
                data: res.data,
                action: "edit",
                status: res.status,
              };
              this.close(actionData);

              setTimeout(function() {
                root.nextStep();
              }, 3000);
            } else {
              this.SnackbarVal.color = "error";
              this.SnackbarVal.message = res.message;
              this.SnackbarVal.snackbar = true;
              setTimeout(function() {
                root.nextStep();
              }, 3000);
            }
          });
      } else {
        commonService
          .insertFormData(formSchema, "proc_package_eco")
          .then((res) => {
            if (res.status == 1) {
              let actionData = {
                message: res.message,
                data: res.data,
                action: "add",
                status: res.status,
              };
              this.close(actionData);
              setTimeout(function() {
                root.nextStep();
              }, 3000);
            } else {
              this.SnackbarVal.color = "error";
              this.SnackbarVal.message = res.message;
              this.SnackbarVal.snackbar = true;

              setTimeout(function() {
                root.nextStep();
              }, 3000);
            }
          });
      }
    },
    editItem(index, item) {
      this.row_index = index;
      this.formSchema = item;
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth",
      });
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "proc_package_eco").then((res) => {
        if (res.status == 1) {
          this.items.splice(row_index, 1);
          this.getDataFromApi();
          this.SnackbarVal.color = "success";

        } else {
          this.SnackbarVal.color = "error";
        }
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
        this.confirmModel = false;
        this.dialog2 = false;
      });
    },
    nextStep() {
      this.Loader = false;
      this.$refs.form.reset();
      this.$emit("emitForm2", 3);
    },

    previous() {
      this.Loader = false;
      this.SnackbarVal.snackbar = false;
      this.$emit("emitForm2", 1);
    },

    close(res) {
      let $this = this;
      if (res.status == 1) {
        if (res.action == "add") {
          $this.items.unshift({ ...res.data });
        }
        if (res.action == "edit") {
          let findindex = this.items.findIndex(
            (item) => item.id == res.data.id
          );
          this.row_index = findindex;
          this.$set(this.items, this.row_index, { ...res.data });
          this.row_index = "";
          this.formSchema.id = 0;
        }
      }
      this.Loader = true;
      this.SnackbarVal.color = "success";
      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
    },
    reset() {
      if (this.formSchema.id > 0) {
        close(0);
      } else {
        this.$refs.form.reset();
      }
    },
  },
  watch: {
    package_id() {
      this.formSchema.package_id = this.package_id;
      commonService
        .getAllDataById(this.package_id, "proc_package_eco_by_id")
        .then((res) => {
            this.items = res.data;
            this.loading = false;
        })
        .catch((err) => {
           console.log(err)
        });
    },
  },
  mounted() {
    this.getDataFromApi();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/procurement/package_revision/step_forms/EcoHeadRevision.vue